import { render } from "./ProposalModal.vue?vue&type=template&id=779d1e1d&scoped=true"
import script from "./ProposalModal.vue?vue&type=script&lang=ts"
export * from "./ProposalModal.vue?vue&type=script&lang=ts"

import "./ProposalModal.vue?vue&type=style&index=0&id=779d1e1d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-779d1e1d"

export default script